import api from 'src/config/api';
import {
	IAnnotationLabel,
	IAnnotationLabelShortInfo,
	ICreateUpdateAnnotationLabelRequest,
} from 'src/features/annotation_label/domain/types';

export const annotationLabelApi = {
	createAnnotationLabel: async (
		requestBody: ICreateUpdateAnnotationLabelRequest,
		siteSlug: string,
	): Promise<IAnnotationLabel> => {
		const response = await api.post(
			`/api/v1/annotation-label`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	updateAnnotationLabel: async (
		annotationLabelId: number,
		requestBody: ICreateUpdateAnnotationLabelRequest,
		siteSlug: string,
	): Promise<IAnnotationLabel> => {
		const response = await api.patch(
			`/api/v1/annotation-label/${annotationLabelId}`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	getAnnotationLabels: async (
		requestParams: { page?: number },
		siteSlug: string,
	): Promise<IPaginatedResponse<IAnnotationLabel>> => {
		const { page = 1 } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
		});

		const response = await api.get(`/api/v1/annotation-labels?${params}`, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	getAnnotationLabel: async (
		annotationLabelId: number,
		siteSlug: string,
	): Promise<IAnnotationLabel> => {
		const response = await api.get(
			`/api/v1/annotation-label/${annotationLabelId}`,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	getAnnotationLabelsShortInfo: async (
		siteSlug: string,
	): Promise<IAnnotationLabelShortInfo[]> => {
		const response = await api.get(`/api/v1/annotation-labels/short-info`, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},
};
